import { useEffect, useState, useCallback } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { Reviews } from "@/components/site/Reviews";
import { ServiceArea } from "@/components/site/ServiceArea";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { AuthCallback } from "@/components/auth/AuthCallback";
import { Login } from "@/components/auth/Login";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { Dashboard } from "@/components/dashboard/Dashboard";
import { getStats } from "@/lib/api";

const Home = () => {
  const [stats, setStats] = useState(null);
  const refreshStats = useCallback(() => { getStats().then(setStats).catch(() => {}); }, []);
  useEffect(() => { refreshStats(); }, [refreshStats]);

  return (
    <div className="App">
      <Header />
      <main>
        <Hero stats={stats} />
        <Services />
        <Reviews onPosted={refreshStats} />
        <ServiceArea />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRouter />
      <Toaster theme="dark" position="top-center" toastOptions={{ style: { borderRadius: 0, border: "2px solid #7CB518", background: "#0a0a0a", color: "#fff" } }} />
    </BrowserRouter>
  );
}

export default App;
